<template>
<div v-if="active" class="modal is-large" :class="{ 'is-active': active }">
    <div class="modal-background"></div>
    <div class="modal-content">
        <div class="custom-modal-box">
            <choose-server-step v-if="currentStep == 'choose_server_step'"></choose-server-step>
            <ssh-key-step v-if="currentStep == 'ssh_key_step'" :server="selectedServer"></ssh-key-step>
            <file-details-step v-if="currentStep == 'file_details_step'" :server="selectedServer"></file-details-step>
        </div>
    </div>
    <button @click="close" class="modal-close is-large" aria-label="close"></button>
</div>
</template>

<script>
import Api from '@/api';

export default {
    components: {
        'choose-server-step': require('@/components/Files/AddFile/ChooseServerStep.vue').default,
        'ssh-key-step': require('@/components/Files/AddFile/SshKeyStep.vue').default,
        'file-details-step': require('@/components/Files/AddFile/FileDetailsStep.vue').default,
    },

    data() {
        return {
            active: false,
            // name: '',
            // token: '',
            storingFile: false,
            //
            currentStep: 'choose_server_step',
            selectedServer: null,
        }
    },

    mounted() {
        this.listenEvents();
    },

    methods: {
        emitStoreFileEvent() {
            Event.$emit('storeFile');
        },

        close() {
            if (!this.storingFile) {
                this.active = false;
                Event.$emit('addFileClosed');
            }
        },

        listenEvents() {
            var vm = this;

            Event.$on('showAddFile', () => {
                vm.active = true;
            });

            Event.$on('closeAddFile', () => {
                vm.close();
            });

            Event.$on('storingFileLoaderUpdated', (storingFile) => {
                vm.storingFile = storingFile;
            });

            Event.$on('moveToSshKeyStep', (server) => {
                this.selectedServer = server;
                this.currentStep = 'ssh_key_step';
            });

            Event.$on('moveToFileDetailsStep', (server) => {
                this.selectedServer = server;
                this.currentStep = 'file_details_step';
            });
        },
    },

    watch: {
        currentStep(currentStep) {
            Event.$emit('currentAddServerStepUpdated', currentStep);
        },
    },
}
</script>
